import config from "../../config"
import RequestService from "../RequestService"

const deleteEquipmentItem = (id, successCallback, failureCallback) => {
  RequestService.delete(`${config.backendUrl}/equipment_items/${id}`, successCallback, failureCallback)
}

export default deleteEquipmentItem;